import React from 'react';

import {AttachDropdownItem} from './AttachDropdownConstants';
import AttachDropdownOption from './AttachDropdownOption';
import {RenderAttachDropdownOptionInfo} from './AttachDropdownOptionsMenu';

export default function getDefaultRenderAttachDropdownOptionInfo(
  option: AttachDropdownItem
): RenderAttachDropdownOptionInfo {
  return {
    optionContent: <AttachDropdownOption result={option} />,
    hoverable: true,
    clickable: true,
  };
}
